// Simple version without swipe gestures
import {
  Dimensions,
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";
import React, { useState } from "react";
import AppFonts from "../../../Constants/AppFonts";
import AppImages from "../../../Constants/AppImages";
import AppColors from "../../../Constants/AppColors";
import Paid from "./Paid";
import Appstyles from "../../../Constants/AppStyles";

const PaidInvoice = ({ navigation }) => {
  const [activeTab, setActiveTab] = useState("paid");

  const t = (key) => {
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }
    return key;
  };

  const tabs = [
    { key: "paid", label: "Paid", component: Paid },
    { key: "pending", label: "Pending", component: Paid },
    { key: "failed", label: "Failed Transaction", component: Paid },
  ];

  const renderContent = () => {
    const activeTabData = tabs.find((tab) => tab.key === activeTab);
    if (activeTabData) {
      return <activeTabData.component tabType={activeTabData.key} />;
    }
    return <Paid />;
  };

  return (
    <SafeAreaView
      style={[Appstyles.safe, { backgroundColor: AppColors.sandal }]}
    >
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity
            style={Appstyles.Arrowstyle}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image source={AppImages.Backbtn} style={Appstyles.ArrowImage} />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>
            {t("common:translation.Paid Invoices")}
          </Text>
        </View>
        <View style={Appstyles.rc}>
          <Image
            source={AppImages.VechicleNoti}
            style={Appstyles.VehicleImage}
            resizeMode="contain"
          />

          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>

      {/* Custom Tab Bar - Simple Version */}
      <View style={styles.tabContainer}>
        {tabs.map((tab) => (
          <TouchableOpacity
            key={tab.key}
            style={[styles.tab, activeTab === tab.key && styles.activeTab]}
            onPress={() => setActiveTab(tab.key)}
          >
            <Text
              style={[
                styles.tabText,
                activeTab === tab.key && styles.activeTabText,
              ]}
            >
              {tab.key === "pending"
                ? t("common:translation.Pending")
                : tab.label}
            </Text>
            {activeTab === tab.key && <View style={styles.tabIndicator} />}
          </TouchableOpacity>
        ))}
      </View>

      {/* Content */}
      <ScrollView style={{ flex: 1, backgroundColor: AppColors.sandal }}>
        {renderContent()}
      </ScrollView>
    </SafeAreaView>
  );
};

export default PaidInvoice;

const styles = StyleSheet.create({
  safe: {
    flex: 1,
    backgroundColor: AppColors.sandal,
  },
  tabContainer: {
    flexDirection: "row",
    backgroundColor: AppColors.white,
    marginTop: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    elevation: 2,
  },
  tab: {
    flex: 1,
    alignItems: "center",
    paddingVertical: 15,
    position: "relative",
  },
  activeTab: {
    // Active tab styles if needed
  },
  tabText: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    color: "#9C4900CC",
    textAlign: "center",
  },
  activeTabText: {
    fontFamily: AppFonts.OverpassBold,
    color: "#8F4300",
  },
  tabIndicator: {
    position: "absolute",
    bottom: 0,
    height: 3,
    width: "100%",
    backgroundColor: "#8F4300",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
  },
});
